import React from "react";
import { Spinner } from "../ui";

export function StravaIcon({ className = "w-5 h-5", ...props }) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      {...props}
    >
      <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7.008 13.828h4.172" />
    </svg>
  );
}

export function StravaConnectButton({
  onClick,
  loading = false,
  isConnected = false,
  disabled = false,
  className = "",
  variant = "connect", // 'connect' | 'disconnect' | 'status'
}) {
  if (variant === "disconnect") {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className={`inline-flex items-center justify-center gap-2 px-3 py-1.5 text-xs font-medium text-red-400 bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      >
        {loading ? <Spinner size="sm" /> : null}
        Desconectar Strava
      </button>
    );
  }

  if (isConnected && variant === "status") {
    return (
      <div
        className={`inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold text-white bg-[#FC4C02]/20 border border-[#FC4C02]/40 rounded-lg ${className}`}
      >
        <StravaIcon className="w-4 h-4 text-[#FC4C02]" />
        <span>Conectado ao Strava</span>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2.5 px-4 py-2.5 text-sm font-bold text-white bg-[#FC4C02] hover:bg-[#E34402] active:bg-[#C93B00] rounded-xl shadow-md transition-all cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
    >
      {loading ? (
        <Spinner size="sm" className="text-white" />
      ) : (
        <StravaIcon className="w-5 h-5 text-white" />
      )}
      <span>{loading ? "Conectando..." : "Conectar com Strava"}</span>
    </button>
  );
}

export default StravaConnectButton;
